import { render, staticRenderFns } from "./AllPropsSettingsTemplateSelector.vue?vue&type=template&id=d053d064"
import script from "./AllPropsSettingsTemplateSelector.vue?vue&type=script&lang=js"
export * from "./AllPropsSettingsTemplateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports